import { render, staticRenderFns } from "./TachographDriverDayDetail.vue?vue&type=template&id=3fa23dd4&"
import script from "./TachographDriverDayDetail.vue?vue&type=script&lang=js&"
export * from "./TachographDriverDayDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports